<template>
  <div class="no-availability">
    We’re sorry, but this property isn't taking reservations on our site right now.
    <a :href="searchUrl">Don’t worry you can find other nearby properties here</a>
  </div>
</template>

<script>
export default {
  props: {
    town: String,
    nights: String,
    checkInDate: String,
    checkOutDate: String,
  },
  data: function () {
    return {
      searchUrl: "/searches/custom?search[region]="
    }
  },
  beforeMount() {
    let checkIn = new Date(this.checkInDate).toLocaleDateString('fr-CA');
    this.searchUrl = this.searchUrl + this.town + "&search[check_in_on]=" + checkIn + "&search[minimum_nights]=" + this.nights
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';
.no-availability {
  padding: 1rem;
  color: #D22F30;
  margin: 1.25rem;
  line-height: 1rem;
  font-size: 0.875rem;
  background: #FFF8DC;
  border-radius: 0.25rem;
  border: 1px solid #FFDE5A;

  a {
    color: #424F98;
    font-weight: 700;
  }

  @media #{$desktop} {
    margin: 0 0 1.25rem 0;
  }
}
</style>